// Marchio Tecnoside: esagono arancione con esagono pieno al centro, senza sfondo.
function hex(r: number): string {
  const p: string[] = [];
  for (let i = 0; i < 6; i++) {
    const a = ((-90 + 60 * i) * Math.PI) / 180;
    p.push(`${(50 + r * Math.cos(a)).toFixed(2)},${(50 + r * Math.sin(a)).toFixed(2)}`);
  }
  return `M${p.join('L')}Z`;
}

const RING = `${hex(46)}${hex(32)}`;
const CORE = hex(20);

export function Logo({ size = 34 }: { size?: number }) {
  return (
    <svg className="tecnoside-logo" width={size} height={size} viewBox="0 0 100 100" aria-label="Tecnoside" role="img">
      <path d={RING} fill="#EA5A26" fillRule="evenodd" stroke="#EA5A26" strokeWidth={3} strokeLinejoin="round" />
      <path d={CORE} fill="#EA5A26" stroke="#EA5A26" strokeWidth={3} strokeLinejoin="round" />
    </svg>
  );
}
